import React from "react";
import {
  ConnectionStatus,
  IConnectionsReport,
  IConnectionsSearchParams,
} from "../../Interfaces/connections";
import TableTemplate from "../TableTemplate/tableTemplate";
import { getConnectionsTable } from "../../Requests/connections";
import TableUI from "./TableUI";

interface IConnectionsTable {
  searchParam: IConnectionsSearchParams;
  connectionStatus: ConnectionStatus;
}

export const ConnectionsTable: React.FC<IConnectionsTable> = React.memo(
  ({ connectionStatus, searchParam }: IConnectionsTable) => {
    return (
      <TableTemplate<IConnectionsSearchParams, IConnectionsReport>
        TableUI={({ reports, onAction }) => (
          <TableUI reports={reports} onAction={onAction} />
        )}
        getDataTable={(_, o, pageSize) =>
          getConnectionsTable(searchParam, o, pageSize, connectionStatus)
        }
      />
    );
  }
);

export default ConnectionsTable;
